import { render } from "./LoginView.vue?vue&type=template&id=33707072"
import script from "./LoginView.vue?vue&type=script&scoped=true&lang=js"
export * from "./LoginView.vue?vue&type=script&scoped=true&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=33707072&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__